import { type DocumentHead } from './document-head';

/**
 * 三個公開頁的 head——**唯一的一份**。
 *
 * 讀者有兩種，而且兩種都要照顧到：
 *
 * - 不執行 JS 的（LINE／FB／X 的預覽爬蟲）：拿預渲染的 HTML，見 `prerender-head.ts`
 * - 執行 JS 的（瀏覽器、Googlebot）：拿 `routes.tsx` 的 `PublicHead` 設的值
 *
 * 在此之前這組值寫在兩個地方（`scripts/prerender.mjs` 與 `routes.tsx`），而首頁的標題
 * 已經分岔了：預渲染是「Talkomo — 用聊天做生意」，JS 跑完變成「Talkomo」——
 * **Google 看的是 JS 跑完的那一個**。沒有任何錯誤訊息，要把兩邊的輸出擺在一起才看得出來（E6-08）。
 *
 * 首頁那一筆另外有測試盯著 `index.html`：那份靜態 head 就是首頁的 head，三個值必須一樣。
 */
export const PUBLIC_HEADS = {
  '/': {
    title: 'Talkomo — 用聊天做生意',
    description:
      'Talkomo：LINE、Messenger、IG、官網聊天，一個收件匣。行銷自動化、AI 客服、門市導購——用對話把線上線下的生意接起來。',
    canonicalPath: '/',
  },
  '/privacy': {
    title: '隱私權政策',
    description: 'Talkomo 如何蒐集、使用與保護你和你顧客的資料，以及你可以行使的權利。',
    canonicalPath: '/privacy',
  },
  '/terms': {
    title: '服務條款',
    description: '使用 Talkomo 的條款：帳號、付費、資料歸屬與服務範圍。',
    canonicalPath: '/terms',
  },
} as const satisfies Record<string, Required<DocumentHead>>;

export type PublicPath = keyof typeof PUBLIC_HEADS;
